import { IconProps } from "../../utils/global-types/global-types";

const RadioButtonSelectedIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-[18px] h-[18px]"}
    {...rest}
  >
    <circle cx="9" cy="9" r="6" stroke="#A3A3A3" strokeWidth="1" />
    <circle cx="9" cy="9" r="3" fill="currentColor" />
  </svg>
);

export default RadioButtonSelectedIcon;
